import enquireJs from 'enquire.js'

const enquireScreen = function (call) {
  const hanlder = {
    match: function () {
      // [layout-probe] 临时探针
      console.info('[layout-probe] enquire match(max-width:767.99px), innerWidth=', window.innerWidth)
      call && call(true)
    },
    unmatch: function () {
      // [layout-probe] 临时探针
      console.info('[layout-probe] enquire unmatch, innerWidth=', window.innerWidth)
      call && call(false)
    }
  }
  enquireJs.register('only screen and (max-width: 767.99px)', hanlder)
}

export default enquireScreen



// WEBPACK FOOTER //
// ./src/utils/device.js